import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin } from "lucide-react";
import { BRAND } from "@/constants/brand";
import { ManagedImage } from "@/hooks/useAssets";

export default function PopPandaGo() {
  return (
    <div data-testid="ppgo-page" className="section-pad">
      <div className="container-pp grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="text-[11px] uppercase tracking-[0.22em] text-brand-charcoal/55">Retail</div>
          <h1 className="editorial-h1 text-5xl md:text-7xl mt-3">Pop Panda Go — our retail flag.</h1>
          <p className="mt-6 text-brand-charcoal/70 text-lg max-w-xl leading-relaxed">
            The first Pop Panda retail counter, where the freezer meets the customer. Drop in for
            seasonal experiments, full-menu tastings and a quiet corner that smells like fruit.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" className="btn-pill btn-primary" data-testid="ppgo-wa">WhatsApp the store</a>
            <Link to="/event-orders" className="btn-pill btn-outline-dark" data-testid="ppgo-event">Plan an event</Link>
          </div>
          <div className="mt-12 card-elevated p-6 max-w-md">
            <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] text-brand-red"><MapPin size={14} /> Visit us</div>
            <div className="font-display text-3xl mt-2">{BRAND.addresses.retail.line1}</div>
            <address className="not-italic mt-2 text-sm text-brand-charcoal/70">{BRAND.addresses.retail.lines.join(", ")}</address>
          </div>
        </div>
        <div className="lg:col-span-5">
          <ManagedImage slot="popandago.hero" alt="Pop Panda Go" fallback="https://images.unsplash.com/photo-1488477181946-6428a0291777?q=80&w=1400&auto=format&fit=crop" className="rounded-3xl aspect-[4/5] w-full object-cover" />
        </div>
      </div>
    </div>
  );
}
